function init_walkanimpolice(from_php){
    var main=$(".place.walkanimpolice");
    var spineResource;
    if(_ON_DEV){
        console.log(from_php)
    }

    $.addToPlacePreloader(function(){
//        _moduleEvents.trigger("loadEnd");
    },[],{addToLoader:1});

    var animCanv=main.find("#techearAnim");
    var animArr=[0];
    var cumState={"state":""};


    var soundIndex=_moduleTimeHandler.getNewIndex();
    var lastSound=false;

//    from_php.anim_max=2;

    function initView(){
        //anim_max
        var name,need,name_push;

        for(name in from_php.level_need){
            need=intval(from_php.level_need[name]);
            if(need<=from_php.girls_count){
                main.find(".showGoodJS[data-i='"+name+"']").removeClass("unable");
                name_push=name;
                if($.isNumeric(name_push)){
                    name_push=intval(name_push);
                }
                animArr.push(name_push);
            }
        }



    }
    initView();
    if(animArr.length==0){
        return false;
    }


    function girlOne(qconf){
        qconf=$.extend(true,{
            step_arr:[1,2],
            anim_arr:[],
            img:"",
            anim_id:0
        },qconf);
        this.qtype=0;
        this.anim_arr=copyArray(qconf.anim_arr);
        this.step_max=mt_rand(qconf.step_arr[0],qconf.step_arr[1]);
        this.step=mt_rand(0,this.step_max);
        this.conf_cur=qconf;

        this.is_active=1;

        var thc=this;
        myPixiElement.spine.call(this,{
            img:qconf.img,
            spine_conf:{
                anim_name:this.anim_arr[0],
                anim_loop:true,
                spineResource:spineResource,
                onAnimComplete:function(){
                    if(qconf.anim_id=="6"){
                        var cur_anim=thc.takeCurAnimName();

                        if(cur_anim=="animation6"){
                            //after cum anim
                            cumState.state="";
                            thc.conf.spine_conf.anim_loop=true;
                            thc.playAnim("animation7");
                            return false;
                        }
                        if(thc.is_active==0){
                            //play stand by after cum;

                            return false;
                        }
                        if(cumState.state=="wait" && (cur_anim=="animation4" || cur_anim=="animation5")){
                            thc.is_active=0;
                             thc.conf.spine_conf.anim_loop=false;
                            thc.playAnim("animation6");//cum anim



                            _moduleTimeHandler.setOne(soundIndex,function(){
                                if(lastSound){
                                    _mySound.stopSound(lastSound);
                                }
                                _mySound.playSound("mmoan");
                            },700);





                            return false;
                        }
                    }


                    thc.step++;
                    if(thc.step>=thc.step_max){
                        thc.step=0;
                        if(thc.qtype==0){
                            thc.qtype=1;
                            thc.step_max=1;
                            thc.playAnim(thc.anim_arr[mt_rand(0,thc.anim_arr.length-1)]);
                        }
                        else{
                            thc.qtype=0;
                            thc.step_max=mt_rand(qconf.step_arr[0],qconf.step_arr[1]);
                            thc.playAnim(thc.anim_arr[0]);
                        }
                    }
                    return true;
                }
            }
        });

        this.alpha=0;
    }
    girlOne.prototype = Object.create(myPixiElement.spine.prototype);
    girlOne.prototype=$.extend(girlOne.prototype,{
        rePlay:function(){
            if(this.is_active){
                return false;
            }
            this.is_active=1;
            this.playAnim(this.anim_arr[0]);
        }
    });





    function animTeacher(animCanv,anim_ava){
        if(anim_ava.length==0){
            return false;
        }
        this.anim_conf={
            "0":{y:0,x:0,url:_IMG_SERV+"/gfx/place/walkanimpolice/0/skeleton.json",arr:["animation","animation2","animation3","animation4"]},
            "1":{y:0,x:0,url:_IMG_SERV+"/gfx/place/walkanimpolice/1/skeleton.json",arr:["animation1","animation2","animation3"]},
            "2":{y:0,x:0,url:_IMG_SERV+"/gfx/place/walkanimpolice/2/skeleton.json",arr:["animation","animation2","animation3"]},
            "3":{y:0,x:0,url:_IMG_SERV+"/gfx/place/walkanimpolice/3/skeleton.json",arr:["animation"]},
            "4":{y:0,x:0,url_key:"anim3",arr:["animation2"]},
            "5":{y:0,x:0,url_key:"anim3",arr:["animation3"]},
            "6":{y:0,x:0,url_key:"anim3",arr:["animation4","animation5"]},
            "cum":{y:0,x:0,url_key:"anim3",arr:["animation5"]},
        };
        this.app=new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:animCanv[0]
        });
        this.mainCointainer=new PIXI.Container();
        this.app.stage.addChild(this.mainCointainer);
        this.spineArr={};
        this.state=0;//number or cum;
        this.anim_ava=copyArray(anim_ava);
        this.anim_id=-1;
        var app=this.app;
        this.isCum=0;
        this.curSound="";
        this.cumIndex=_moduleTimeHandler.getNewIndex();

        this.block_anim=0;



        var loaderMain = new PIXI.loaders.Loader();
        var i,bum;
        var loaderOptions = {
            crossOrigin: true
        };
        for(i in this.anim_conf){
            bum=this.anim_conf[i];
            if(in_array(i,this.anim_ava)){
                if(typeof bum.url!="undefined"){
                    bum.url_key="anim"+i;
                    loaderMain.add(bum.url_key,bum.url);
                }
            }
        }
        if(in_array(4,this.anim_ava)){
            loaderMain.add("unlock",_IMG_SERV+"/gfx/place/walkanimpolice/unlock/skeleton.json");
        }

        loaderMain.load(function(loader, resources){
            spineResource=resources;



            animCanv.trigger("was_loaded");

        });
        _moduleEvents.one("moduleClear",function(){
            if(typeof app!="undefined" && app!=null){
                app.destroy();
            }
            if(typeof loaderMain.reset!="undefined"){
                loaderMain.reset();
            }
        });
        return this;
    };
    animTeacher.prototype={
        init:function(){




            var thc=this;
            this.main_ticker=this.app.ticker.add(
                function(delta){thc.gameLoop(delta);}
            );
            var i,anim_id,conf;

            for(i in this.anim_ava){
                anim_id=this.anim_ava[i];
                conf=this.anim_conf[anim_id];
                if(anim_id!="cum"){
                    this.spineArr[anim_id]=new girlOne({img:conf.url_key,anim_arr:copyArray(conf.arr),anim_id:anim_id});
                    this.mainCointainer.addChild(this.spineArr[anim_id]);
                }

            }

            if(in_array(4,this.anim_ava)){
                this.spineArr["unlock"]=new myPixiElement.spine({
                    img:"unlock",
                    spine_conf:{
                        anim_loop:false,
                        spineResource:spineResource,
                        onAnimComplete:function(){
                            if(thc.anim_id==4){
                                thc.showAnim(4,1);
                            }
                        }
                    }
                });
                this.spineArr["unlock"].alpha=0;
                this.mainCointainer.addChild(this.spineArr["unlock"]);
            }


            this.showAnim(this.anim_ava[0]);

        },

        playSound:function(type_id){
            _moduleTimeHandler.clear(soundIndex);
            var type2obj={

                "0":{name:"walk_lose_all","duration":9000},
                "1":{name:"girl_moan_new","duration":9000},
                "2":{name:"pvpsuck","duration":5000},
                "4":{name:"girl_moan_new","duration":3000},
                "5":{name:"girl_moan","duration":3000},
                "6":{name:"girl_play","duration":0},
            };
            if(typeof type2obj[type_id]=="undefined"){
                return false;
            }
            var nameObj=type2obj[type_id];
            if(lastSound){
                _mySound.stopSound(lastSound);
            }
            if(nameObj.name){

                var thc=this;
                if(nameObj.duration){
                    _moduleTimeHandler.set(soundIndex,function(){
                        lastSound=_mySound.playSound(nameObj.name);
                    },nameObj.duration);
                }
                else{
                    lastSound=_mySound.playSound(nameObj.name);
                }
            }
        },
        gameLoop:function(delta){
            var i,k,anim_id;
            for(anim_id in this.spineArr){
                this.spineArr[anim_id].myUpdate(delta);
            }
        },
        showAnim:function(anim_id,force){


            var thc=this;

            if(cumState.state=="wait"){
                return false;
            }

            if(anim_id==6 && this.anim_id==6 && this.spineArr["6"].is_active==0){
                this.spineArr["6"].fadeOut(15,{onEnd:function(){
                        thc.anim_id=-1;
                        thc.showAnim(6);
                }});
            }




            if((this.anim_id==anim_id || this.block_anim ) && !force){
                return false;
            }

            if(anim_id==4){
                if(!force){
                    //unlock
                    this.block_anim=1;
                    this.spineArr[this.anim_id].fadeOut(15,{onEnd:function(){
                        thc.spineArr["unlock"].alpha=1;
                        thc.spineArr["unlock"].playAnim("animation");
                        if(lastSound){
                            _mySound.stopSound(lastSound);
                        }
                        _moduleTimeHandler.setOne(soundIndex,function(){
                            _mySound.playSound("soccer_target");
                        },2300);
                    }});
                }
                else{
                    this.spineArr["unlock"].alpha=0;
                    this.block_anim=0;
                    this.spineArr[anim_id].fadeIn(15,{onEnd:function(){
                          thc.playSound(4);
                    }});
                }
            }
            else{
                function qShow(){
                    thc.spineArr[anim_id].rePlay();
                    thc.spineArr[anim_id].fadeIn(15,{onEnd:function(){
                            thc.playSound(anim_id);
                    }});
                }
                if(this.anim_id!=-1 && this.anim_id!=anim_id ){
                    this.spineArr[this.anim_id].fadeOut(15,{onEnd:function(){
                            qShow();
                    }});
                }
                else{
                    qShow();
                }
            }



            this.anim_id=anim_id;
        },
        showCum:function(){
            if(!in_array("cum",this.anim_ava) || this.block_anim){
                return false;
            }
            var thc=this;
            if(this.anim_id!=6){

                this.showAnim(6);
                _moduleTimeHandler.setOne(this.cumIndex,function(){
                    cumState.state="wait";
                },2000);

            }
            else{
                if(this.spineArr["6"].is_active==0){
                    this.spineArr["6"].fadeOut(15,{onEnd:function(){
                            thc.anim_id=-1;
                            thc.showCum();
                    }});
                }
                else{
                    cumState.state="wait";
                }


            }
        },
    };
    main.find(".book[g_id='1']").on("open",function(e,val){
        if(typeof from_php.level_need[val]=="undefined"){
            return false;
        }
        var need=intval(from_php.level_need[val]);
        $(this).find(".girlNeedJS").html(need-from_php.girls_count);
    });


    var animObj=new animTeacher(animCanv,animArr);
    animCanv.one("was_loaded",function(){
        $.triggerPlacePreloader(1);
        animObj.init();
        main.find(".showGoodJS").click(function(){
            var th=$(this),val=th.attr("data-i");
            if(th.is(".unable")){
                main.find(".book[g_id='1']").bookUse("show",1,val);
                return false;
            }
            if(val=="cum"){
                animObj.showCum();
            }
            else{
                animObj.showAnim(val);
            }

        });
    });







    _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });
}
